// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tab3_style_wrapper__1kKGS","buttons":"Tab3_style_buttons__2F6in","text":"Tab3_style_text__1Dzky","picture":"Tab3_style_picture__2_iSb"};